import { toUpperCase } from '@/helpers/toUpperCase';
import IBusinessUnit, { HorarioEmpresa } from '@/interfaces/business-units';

export default class BusinessUnitModel {
  public id: string;
  public cnpj: string;
  public razaoSocial: string;
  public nomeFantasia?: string;
  public telefone?: string;
  public endereco?: string;
  public cep?: string;
  public numero?: number;
  public complemento?: string;
  public bairro?: string;
  public cidade?: string;
  public estado?: string;
  // tslint:disable-next-line: variable-name
  public administrador_resp?: string;
  // tslint:disable-next-line: variable-name
  public administrador_resp_email?: string;
  // tslint:disable-next-line: variable-name
  public administrador_resp_cpf?: string;
  public imagem?: string;
  public ativo: boolean;

  public horarios: HorarioEmpresa[];

  constructor(_initialValues?: IBusinessUnit) {
    const initialValues = _initialValues || {
      id: '',
      cnpj: '',
      razaoSocial: '',
      nomeFantasia: '',
      telefone: '',
      endereco: '',
      cep: '',
      // numero: 0,
      complemento: '',
      bairro: '',
      cidade: '',
      estado: '',
      administrador_resp: '',
      administrador_resp_email: '',
      administrador_resp_cpf: '',
      imagem: '',
      ativo: true,
      horarios: []
    };
    this.id = initialValues.id;
    this.cnpj = initialValues.cnpj;
    this.razaoSocial = initialValues.razaoSocial;
    this.nomeFantasia = initialValues.nomeFantasia;
    this.telefone = initialValues.telefone;
    this.endereco = initialValues.endereco;
    this.cep = initialValues.cep;
    this.numero = initialValues.numero;
    this.complemento = initialValues.complemento;
    this.bairro = initialValues.bairro;
    this.cidade = initialValues.cidade;
    this.estado = initialValues.estado;
    this.administrador_resp = initialValues.administrador_resp;
    this.administrador_resp_email = initialValues.administrador_resp_email;
    this.administrador_resp_cpf = initialValues.administrador_resp_cpf;
    this.imagem = initialValues.imagem;
    this.ativo = initialValues.ativo;
    this.horarios = initialValues.horarios;    
  }

  public validate(): boolean {
    return !!this.razaoSocial;
  }

  public toJson(): any {
    return {
      id: this.id,
      cnpj: this.cnpj,
      razaoSocial: toUpperCase(this.razaoSocial),
      nomeFantasia: toUpperCase(this.nomeFantasia),
      telefone: this.telefone,
      endereco: toUpperCase(this.endereco),
      cep: this.cep,
      numero: this.numero,
      complemento: toUpperCase(this.complemento),
      bairro: toUpperCase(this.bairro),
      cidade: toUpperCase(this.cidade),
      estado: toUpperCase(this.estado),
      administrador_resp: toUpperCase(this.administrador_resp),
      administrador_resp_email: toUpperCase(this.administrador_resp_email),
      administrador_resp_cpf: toUpperCase(this.administrador_resp_cpf),
      imagem: this.imagem,
      ativo: this.ativo,
      horarios: this.horarios.map(h => {
        let v = {...h};
        v.dia = h.dia.id;
        return v;
      })
    };
  }
}
